/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Card, Button, Form, Row, Col } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Pagination from '../Features/Pagination/Pagination';
import moment from 'moment';

export default function PatientReport() {
  const [patients, setPatients] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [filters, setFilters] = useState({
    status: '',
    patientName: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [patientsPerPage] = useState(5);

  useEffect(() => {
    axios.get('https://project01-n0pn.onrender.com/api/patient/getallpatients')
      .then((response) => {
        setPatients(response.data);
        setFilteredPatients(response.data);
      })
      .catch((error) => {
        console.error('Error fetching patient data:', error);
      });
  }, []);

  // Calculate the number of pages
  const totalPages = Math.ceil(filteredPatients.length / patientsPerPage);

  // Get current patients data for the page
  const indexOfLastPatient = currentPage * patientsPerPage;
  const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;
  const currentPatients = filteredPatients.slice(indexOfFirstPatient, indexOfLastPatient);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const downloadPDF = () => {
    const input = document.getElementById('patient-report');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('patient_report.pdf');
      })
      .catch((error) => {
        console.error('Error generating PDF:', error);
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const applyFilters = () => {
    let filteredData = patients;

    if (filters.patient_nic) {
      filteredData = filteredData.filter(patient => patient.patient_nic.toLowerCase().includes(filters.patient_nic.toLowerCase()));
    }

    if (filters.name) {
      filteredData = filteredData.filter(patient => patient.name.toLowerCase().includes(filters.name.toLowerCase()));
    }

    setFilteredPatients(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [filters]);

  return (
    <Card className='card-container'>
      <Card.Body>
        <Card.Title className='header'>Patient Report</Card.Title>
        <Form>
          <Row>
            <Col>
          <Form.Group controlId="filterPatientNIC">
            <Form.Control
              type="text"
              placeholder="Enter patient nic"
              name="patient_nic"
              value={filters.patient_nic}
              onChange={handleFilterChange}
            />
          </Form.Group>
          </Col>
          <Col>
          <Form.Group controlId="filterName">
            <Form.Control
              type="text"
              placeholder="Enter name"
              name="name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </Form.Group>
          </Col>
          </Row>
        </Form>
        <Button variant="primary" onClick={downloadPDF} className="mt-3">Download as PDF</Button>
        <div id="patient-report" className="mt-3">
          <Table responsive className="table">
            <thead>
              <tr>
              <th>NIC</th>
            <th>Name</th>
            <th>Age</th>
            <th>Gender</th>
            <th>Contact Number</th>
            <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {currentPatients.map((patient) => (
                <tr key={patient.patient_id}>
                  <td>{patient.patient_nic}</td>
              <td>{patient.name}</td>
              <td>{patient.age}</td>
              <td>{patient.gender}</td>
              <td>{patient.contact_number}</td>
              <td>{moment(patient.createdAtPatient).format("MMMM Do YYYY, h:mm:ss a")}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
        </div>
      </Card.Body>
    </Card>
  );
}